module.exports = __webpack_public_path__ + "static/img/20191008005.f3920fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/20191008005.jpg
// module id = /0IT
// module chunks = 45